export const CUSTOMER_COLUMN_IDS = {
  ID: "id",
  NAME: "name",
  SALESFORCE_ID: "salesforceId",
  TAX_NUMBER: "taxNumber",
  SDM_EMAIL: "sdmEmail",
  SUB_TYPE: "subType",
  RELATIONSHIP_TYPE: "relationshipType"
} as const
